import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import useHasPermissions from '../../hooks/useHasPermissions';
import Dashboard from '../../components/Dashboard/Dashboard';

export const DashboardRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.DASHBOARD, role: Roles.VIEWER });

    return <LogicalRoute {...props} component={Dashboard} disabled={disabled} />;
};
